import reduceReducers from 'reduce-reducers'
import createFetchModule from '@utils/store/createFetchModule'
import { FetchActionsWith } from '@typings/generic'
import createFetchSubmodule from '@utils/store/createFetchSubmodule'

export const moduleName = 'reservationsGrid'

const fetchModule = createFetchModule('@store/ReservationsGrid', 'LOAD', moduleName)
const exportReservationsOnExpeditionsSubmodule = createFetchSubmodule('@store/ReservationsGrid', 'EXPORT', moduleName)

export const actionTypes = {
  ...fetchModule.actionTypes,
  exportReservations: exportReservationsOnExpeditionsSubmodule.actionTypes,
}

export default reduceReducers(fetchModule.reducer)

export const actions: FetchActionsWith<typeof actionTypes> = {
  ...fetchModule.actions,
  exportReservations: exportReservationsOnExpeditionsSubmodule.actions.run,
}

export const selectors = {
  ...fetchModule.selectors,
}
